'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = require('./app.controller');

var _app2 = _interopRequireDefault(_app);

var _app3 = require('./app.html');

var _app4 = _interopRequireDefault(_app3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {},
  controller: _app2.default,
  controllerAs: 'app',
  template: _app4.default
};


// WEBPACK FOOTER //
// ./src/app/app.component.js